import {
  Autocomplete,
  Avatar,
  Button,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AppButton from "../shares/AppButton";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { AssociationService } from "../../../service/AssociationService";
import { useNavigate } from "react-router-dom";
import { AddOutlined, CloseOutlined, EditOutlined } from "@material-ui/icons";
import { uploadService } from "../../../service/UploadService";
import { enleverBaliseHtml } from "../../../Helpers/utilsHelper";
import ZoneCouverture from "./ZoneCouverture";
import StandardSkeletoon from "../shares/loader/StandardSkeletoon";
import { LocalisationService } from "../../../service/LocalisationService";

const INIT_ASSOCIATION = {
  nom: "",
  num_nif: "",
  num_stat: "",
  agrement: "",
  annee_creation: "",
  adresse: "",
  logo: "",
  region_couv: "",
  district_couv: "",
  commune_couv: "",
  fokontany_couv: "",
};

const INIT_FORM_ERROR = {
  nom_error: null,
  num_nif_error: null,
  num_stat_error: null,
  agrement_error: null,
  annee_creation_error: null,
  status_asso_error: null,
  adresse_error: null,
  logo_error: null,
  region_couv_error: null,
  district_couv_error: null,
  commune_couv_error: null,
  fokontany_couv_error: null,
};

const INIT_ZONE_COUVERTURE = {
  region_couv: "",
  district_couv: "",
  commune_couv: "",
  fokontany_couv: "",
};

const STATUT_ASSOCIATION = ["ONG", "Association", "Cabinet", "Groupement"];

const AssociationForm = ({ open, onFormClose, onFormOpen, idAssociation }) => {
  const [currentAssociation, setCurrentAssociation] =
    useState(INIT_ASSOCIATION);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [zoneCouverture, setZoneCouverture] = useState(INIT_ZONE_COUVERTURE);
  const [submited, setSubmited] = useState(false);
  const [submiting, setSubmitting] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [associationLogo, setAssociationLogo] = useState(null);
  const { Toast, showToast } = useToast();
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [communes, setcCommunes] = useState([]);

  const handleFormClose = () => {
    onFormClose();
    handleInitAll();
  };

  const handleInitAll = () => {
    setFormErrors(INIT_FORM_ERROR);
    setCurrentAssociation(INIT_ASSOCIATION);
    setSubmited(false);
  };

  const handleChangeAssociationData = (e) => {
    const { name, value } = e.target;
    setCurrentAssociation({ ...currentAssociation, [name]: value });
  };

  const handleFetchRegions = () => {
    LocalisationService.getAllRegions().then((res) => {
      if (res && res.data) {
        setRegions(Array.from(res.data ?? []).map((r) => r.nom_region));
      }
    });
  };
  const handleFetchDistricts = () => {
    LocalisationService.getAllDistricts().then((res) => {
      if (res && res.data) {
        setDistricts(Array.from(res.data ?? []).map((r) => r.nom_district));
      }
    });
  };
  const handleFetchCommunes = () => {
    LocalisationService.getAllCommunes().then((res) => {
      if (res && res.data) {
        setcCommunes(Array.from(res.data ?? []).map((r) => r.nom_commune));
      }
    });
  };

  const handleFetchAssociation = () => {
    if (idAssociation) {
      setFormLoading(true);
      AssociationService.findOneById(idAssociation)
        .then((res) => {
          if (res && res.success) {
            setCurrentAssociation(res.data);
            setAssociationLogo({
              ...associationLogo,
              logo_link: res.data.logo_link,
            });
          } else {
            setCurrentAssociation(INIT_ASSOCIATION);
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally(() => {
          setFormLoading(false);
        });
    }
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      nom_error: !currentAssociation.nom ? "Le champ nom est requis" : null,
      status_asso_error: !currentAssociation.status_asso
        ? "Le champ statut est requis"
        : null,
      adresse_error: !currentAssociation.adresse ? "Adresse requis" : null,
      annee_creation_error: !currentAssociation.annee_creation
        ? "Année de création requis"
        : null,
      region_couv_error: !currentAssociation.region_couv
        ? "Vous devez mentionner au moins une region de couverture"
        : null,
      district_couv_error: null,
      commune_couv_error: null,
      fokontany_couv_error: null,
      logo_error: uploadingPhoto ? "Photo en cours d'upload" : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleInsertAssociation = () => {
    setSubmited(true);
    setSubmitting(true);
    AssociationService.insert(currentAssociation)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setSubmitting(false);
      });
  };
  const handleEditAssociation = () => {
    setSubmited(true);
    setSubmitting(true);
    try {
      AssociationService.update(currentAssociation)
        .then((res) => {
          if (res && res.success) {
            showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleFormClose();
            // navigate(`/mes-associations/info?uuid=${res.data.uuid}`);
          } else {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .catch((e) => {
          console.log("errr", e);
        })
        .finally((e) => {
          setSubmited(false);
          setSubmitting(false);
        });
    } catch (e) {
      console.log("errr", e);
    }
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      if (currentAssociation.uuid) {
        handleEditAssociation();
      } else {
        handleInsertAssociation();
      }
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      logo_error: "Telechargement du fichier en cours...",
    });
    setUploadingPhoto(true);
    uploadService
      .uploadFile(file)
      .then((res) => {
        if (!(res && res.success)) {
          showToast(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
        } else {
          setCurrentAssociation({
            ...currentAssociation,
            logo: res && res.success ? res.data.file_name : null,
            // logo_link: res && res.success ? res.data.link : null,
          });
          // setFormErrors({
          //   ...formErrors,
          //   photo_error: res && res.success ? null : enleverBaliseHtml(res.error),
          // });
          setAssociationLogo({ ...associationLogo, logo_link: res.data.link });
        }
      })
      .finally(() => {
        setFormErrors({
          ...formErrors,
          photo_error: null,
        });
        setUploadingPhoto(false);
      });
  };

  useEffect(() => {
    if (associationLogo && associationLogo?.name) {
      handleFileUpload(associationLogo);
    }
  }, [associationLogo]);

  useEffect(() => {
    if (open) {
      handleFetchAssociation();
      handleFetchRegions();
      handleFetchDistricts();
      handleFetchCommunes();
    }
  }, [open]);

  useEffect(() => {
    if (currentAssociation) {
      handleCheckDataValidation();
    }
  }, [currentAssociation]);

  const fileInputRef = useRef(null);

  const handleEditPhoto = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAssociationLogo(file);
      setCurrentAssociation({ ...currentAssociation, logo: file.name });
    }
  };

  const handleRemoveZone = (zoneName, zoneType) => {
    let newZone = String(currentAssociation[zoneType])
      .split(";")
      .filter((item) => item !== zoneName);
    setCurrentAssociation({
      ...currentAssociation,
      [zoneType]: newZone.join(";"),
    });
  };

  const handleChangeZone = (event) => {
    const { name, value } = event.target;
    if (String(value).trim() === "")
      showToast(TYPE_NOTIFICATION.ERROR, "La zone ne doit pas être vide");
    let oldZone = currentAssociation[name] || "";
    //delimiteur ;
    let newZone =
      oldZone + (oldZone === "" ? "" : ";") + String(value).replace(";", ",");
    setCurrentAssociation({ ...currentAssociation, [name]: newZone });
    setZoneCouverture({ ...zoneCouverture, [name]: "" });
  };
  const handleChangeCurrentZoneCouverture = (event) => {
    const { name, value } = event.target;
    setZoneCouverture({ ...zoneCouverture, [name]: value });
  };

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} maxWidth="lg">
        <DialogTitle>
          <CardHeader
            title={
              idAssociation ? "Modifier association" : "Nouvelle association"
            }
            sx={{ mb: -4, mt: -2 }}
          />
        </DialogTitle>
        <Paper sx={{ ml: 2, mr: 2 }} elevation={0}>
          <Grid item width={"100%"} display={formLoading ? "" : "none"}>
            <StandardSkeletoon
              show={formLoading}
              row={4}
              col={1}
              escalier={true}
              m={2}
            />
          </Grid>
          <Grid
            maxHeight={"75vh"}
            display={formLoading ? "none" : ""}
            overflow="auto"
          >
            <CardHeader
              sx={{ mb: -3 }}
              avatar={
                <Grid display={"flex"} flexDirection={"column"}>
                  <Grid display={"flex"} flexDirection={"row"}>
                    <Avatar
                      variant="rounded"
                      sx={{
                        m: 1,
                        width: "clamp(75px, 15vw, 125px)",
                        height: "clamp(75px, 15vw, 125px)",
                        fontSize: "clamp(30px, 8vw, 60px)",
                        borderColor: formErrors.photo_error
                          ? "error.main"
                          : "text.primary",
                      }}
                      alt={currentAssociation.nom || "Asso"}
                      src={
                        associationLogo?.logo_link ||
                        currentAssociation.logo_link
                      }
                    />
                    <Grid
                      display={"flex"}
                      height={"100%"}
                      ml={-11}
                      mt={1}
                      flexDirection={"row"}
                      alignItems={"start"}
                    >
                      <IconButton
                        sx={{
                          "&:hover": {
                            color: "red",
                          },
                        }}
                        onClick={handleEditPhoto}
                      >
                        <EditOutlined />
                      </IconButton>
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept="image/png, image/jpeg, image/jpg"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <IconButton
                        sx={{
                          "&:hover": {
                            color: "red",
                          },
                        }}
                      >
                        <CloseOutlined />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <FormHelperText
                    sx={{
                      display: formErrors.logo_error ? "" : "none",
                      color: "error.main",
                    }}
                    id="photo_helper"
                  >
                    {formErrors.logo_error}
                  </FormHelperText>
                </Grid>
              }
            />
            <CardContent>
              <Grid container>
                <Grid item xs={12} md={6} p={1}>
                  <CardHeader
                    sx={{ ml: -2 }}
                    title="Identité de l'association"
                    titleTypographyProps={{ variant: "h6" }}
                  />
                  <FormControl fullWidth>
                    <label>Nom</label>
                    <TextField
                      id="nom"
                      name="nom"
                      onChange={handleChangeAssociationData}
                      size="small"
                      type="text"
                      // error={formErrors.nom_error}
                      value={currentAssociation.nom || ""}
                      error={formErrors.nom_error && submited}
                      helperText={submited ? formErrors.nom_error : ""}
                      placeholder="Nom de l'association"
                      fullWidth
                      aria-describedby="nom_helper"
                    />
                    <FormHelperText id="nom_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Statut</label>
                    <Autocomplete
                      options={STATUT_ASSOCIATION}
                      getOptionLabel={(option) => option}
                      value={currentAssociation.status_asso || ""}
                      onChange={(event, newValue) => {
                        handleChangeAssociationData({
                          target: { name: "status_asso", value: newValue },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          type="text"
                          placeholder="Ex: ONG, Association, Cabinet, Groupement, …"
                          error={formErrors.status_asso_error && submited}
                          helperText={
                            submited ? formErrors.status_asso_error : ""
                          }
                        />
                      )}
                    />
                    <FormHelperText id="status_asso_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>NIF</label>
                    <TextField
                      id="num_nif"
                      name="num_nif"
                      onChange={handleChangeAssociationData}
                      size="small"
                      type="number"
                      value={currentAssociation.num_nif || ""}
                      error={formErrors.num_nif_error && submited}
                      // error={formErrors.num_nif_error && submited}
                      helperText={submited ? formErrors.num_nif_error : ""}
                      placeholder="NIF"
                      fullWidth
                      aria-describedby="num_nif_helper"
                    />
                    <FormHelperText id="num_nif_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>STAT</label>
                    <TextField
                      id="num_stat"
                      name="num_stat"
                      onChange={handleChangeAssociationData}
                      size="small"
                      type="number"
                      value={currentAssociation.num_stat || ""}
                      error={formErrors.num_stat_error && submited}
                      // error={formErrors.num_stat_error && submited}
                      helperText={submited ? formErrors.num_stat_error : ""}
                      placeholder="STAT"
                      fullWidth
                      aria-describedby="num_stat_helper"
                    />
                    <FormHelperText id="num_stat_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Année de création</label>
                    <TextField
                      id="annee_creation"
                      name="annee_creation"
                      onChange={handleChangeAssociationData}
                      size="small"
                      type="number"
                      value={currentAssociation.annee_creation || ""}
                      error={formErrors.annee_creation_error && submited}
                      // error={formErrors.annee_creation_error && submited}
                      helperText={
                        submited ? formErrors.annee_creation_error : ""
                      }
                      placeholder="Année de création"
                      fullWidth
                      aria-describedby="annee_creation_helper"
                    />
                    <FormHelperText id="annee_creation_helper"></FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Adresse</label>
                    <TextField
                      id="adresse"
                      name="adresse"
                      onChange={handleChangeAssociationData}
                      size="small"
                      type="text"
                      value={currentAssociation.adresse || ""}
                      error={formErrors.adresse_error && submited}
                      // error={formErrors.adresse_error && submited}
                      helperText={submited ? formErrors.adresse_error : ""}
                      placeholder="Adresse de l'association"
                      fullWidth
                      aria-describedby="adresse_helper"
                    />
                    <FormHelperText id="adresse_helper"></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} p={1}>
                  <FormControl fullWidth>
                    <CardHeader
                      sx={{ ml: -2 }}
                      title="Zone de couverture"
                      titleTypographyProps={{ variant: "h6" }}
                    />
                    <label>Region</label>
                    <ZoneCouverture
                      labelButton="Ajouter regions"
                      name="region_couv"
                      regions={regions}
                      zoneCouverture={currentAssociation.region_couv || ""}
                      onRemoveItem={(val) =>
                        handleRemoveZone(val, "region_couv")
                      }
                      onChange={(event, value, params, name) =>
                        handleChangeCurrentZoneCouverture({
                          target: { name: "region_couv", value: value },
                        })
                      }
                      onClickAdd={(value) =>
                        handleChangeZone({
                          target: {
                            name: "region_couv",
                            value: zoneCouverture.region_couv,
                          },
                        })
                      }
                      textValue={zoneCouverture.region_couv}
                      label={"Region"}
                    />
                    <FormHelperText id="adresse_helper" sx={{ color: "red" }}>
                      {formErrors.region_couv_error}
                    </FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>District</label>
                    <ZoneCouverture
                      labelButton="Ajouter districts"
                      name="district_couv"
                      regions={districts}
                      zoneCouverture={currentAssociation.district_couv || ""}
                      onRemoveItem={(val) =>
                        handleRemoveZone(val, "district_couv")
                      }
                      onChange={(event, value, params, name) =>
                        handleChangeCurrentZoneCouverture({
                          target: { name: "district_couv", value: value },
                        })
                      }
                      onClickAdd={(value) =>
                        handleChangeZone({
                          target: {
                            name: "district_couv",
                            value: zoneCouverture.district_couv,
                          },
                        })
                      }
                      textValue={zoneCouverture.district_couv}
                      label={"District"}
                    />
                    <FormHelperText
                      id="district_couv_helper"
                      sx={{ color: "red" }}
                    >
                      {formErrors.district_couv_error}
                    </FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <label>Commune</label>
                    <ZoneCouverture
                      labelButton="Ajouter communes"
                      name="commune_couv"
                      regions={communes}
                      zoneCouverture={currentAssociation.commune_couv || ""}
                      onRemoveItem={(val) =>
                        handleRemoveZone(val, "commune_couv")
                      }
                      onChange={(event, value, params, name) =>
                        handleChangeCurrentZoneCouverture({
                          target: { name: "commune_couv", value: value },
                        })
                      }
                      onClickAdd={(value) =>
                        handleChangeZone({
                          target: {
                            name: "commune_couv",
                            value: zoneCouverture.commune_couv,
                          },
                        })
                      }
                      textValue={zoneCouverture.district_couv}
                      label={"Commune"}
                    />
                    <FormHelperText id="commune_helper" sx={{ color: "red" }}>
                      {formErrors.commune_couv_error}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <DialogActions sx={{ justifyContent: "flex-end" }}>
            <AppButton
              loading={submiting}
              disabled={formLoading}
              text={"Enregistrer"}
              size={"medium"}
              variant={"contained"}
              onClick={(e) => handleSubmit()}
            />
            <AppButton
              size={"medium"}
              disabled={formLoading}
              text={"Fermer"}
              variant={"outlined"}
              onClick={(e) => handleFormClose()}
            />
          </DialogActions>
        </Paper>
      </Dialog>
    </>
  );
};

export default AssociationForm;
